import { http } from "./http";

export type ManufacturerSummary = {
    id: string;
    name: string;
};

export type Manufacturer = {
    id: string;
    name: string;
    slug?: string;
    hasLogo: boolean;
    logoUrl: string;
    hasFavicon: boolean;
    faviconUrl: string;
    customFooter: string | null;
};

export enum AccessLevel {
    Admin = 0,
    User = 1,
}

export const accessLevelOptions = [
    { title: "Admin", value: AccessLevel.Admin },
    { title: "User", value: AccessLevel.User },
];

export function accessLevelName(level: AccessLevel): string {
    return level === AccessLevel.Admin ? "Admin" : "User";
}

export type ManufacturerUser = {
    id: string;
    userName: string;
    active: boolean;
    level: AccessLevel;
};

export type ProfileUpdate = {
    name: string;
    slug: string;
    footer: string;
    logoFile: File | null;
    faviconFile: File | null;
};

export const manufacturersApi = {
    async list(): Promise<ManufacturerSummary[]> {
        const { data } = await http.get<ManufacturerSummary[]>("/api/v0/manufacturers");
        return data;
    },
    async get(id: string): Promise<Manufacturer> {
        const { data } = await http.get<Manufacturer>(`/api/v0/manufacturers/${id}`);
        return data;
    },
    async getBySlug(slug: string): Promise<Manufacturer> {
        const { data } = await http.get<Manufacturer>(`/api/v0/manufacturers/slug/${slug}`);
        return data;
    },
    async users(id: string): Promise<ManufacturerUser[]> {
        const { data } = await http.get<ManufacturerUser[]>(`/api/v0/manufacturers/user/${id}`);
        return data;
    },
    async removeUser(manufacturerId: string, userId: string): Promise<void> {
        await http.delete(`/api/v0/manufacturers/user/${userId}/${manufacturerId}`);
    },
    async updateProfile(id: string, update: ProfileUpdate): Promise<void> {
        const form = new FormData();
        form.append("name", update.name);
        form.append("slug", update.slug);
        form.append("footer", update.footer);
        if (update.logoFile) form.append("logoFile", update.logoFile);
        if (update.faviconFile) form.append("faviconFile", update.faviconFile);
        await http.post(`/api/v0/manufacturers/${id}/profile`, form);
    },
    async deleteLogo(id: string): Promise<void> {
        await http.delete(`/api/v0/manufacturers/${id}/logo`);
    },
    async deleteFavicon(id: string): Promise<void> {
        await http.delete(`/api/v0/manufacturers/${id}/favicon`);
    },
};
